import { FC } from 'react';
import { StatusViewProps } from '../../../propTypes';
import { OrderMessage } from '../../OrderMessage';
import { DeliveryDetailsInfo } from '../../DeliveryDetailsInfo';
import TwoColumnLayout from 'components/TwoColumnLayout';

export const SubmittedStatusView: FC<StatusViewProps> = ({ order }: StatusViewProps) => {
  return (
    <TwoColumnLayout
      firstColumn={<DeliveryDetailsInfo order={order} />}
      secondColumn={
        <OrderMessage messageText="Please wait to be contacted by your stylist to confirm the details of your order." />
      }
    />
  );
};
